import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
// import logo from "./assets/8953bd05f459054658ded1284c651e46ae2e1b95.png";
// import s from "./assets/s.png";
import { scrollToSection } from "./utils/ScrollToSection";
// import logo1 from "./assets/Ellipse 1.png";
// import logotext from "./assets/logotext.jpg";
import chatgptimage from "./assets/ChatGPT Image Aug 20, 2025, 04_55_45 PM.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeHash, setActiveHash] = useState("");

  useEffect(() => {
    setActiveHash(location.hash);
  }, [location]);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Who We Are", path: "#who-we-are" },
    { name: "Brand", path: "/business/Startup" },
    { name: "Plans", path: "/Plans" },
    // { name: "How It Works", path: "#how-It-works" },
    { name: "FAQs", path: "#faq" },
    { name: "Testimonials", path: "/Testimonials" },
    { name: "Contact", path: "#form" },
  ];

  const isActive = (item) => {
    return (
      location.pathname === item.path ||
      (item.path.startsWith("#") && activeHash === item.path)
    );
  };

  const handleNavClick = (item) => {
    if (item.path.startsWith("#")) {
      const sectionId = item.path;
      if (location.pathname !== "/") {
        localStorage.setItem("scrollTo", sectionId);
        navigate("/");
      } else {
        scrollToSection(sectionId);
      }
    } else {
      navigate(item.path);
    }
    setMenuOpen(false);
  };

  return (
    <nav className="shadow-md sticky top-0 z-50 backdrop-blur-md bg-white/70">
      <div className="max-w-100vw mx-auto px-12 py-2 flex items-center justify-between h-16">
        <span
          onClick={() => {
            if (location.pathname === "/") {
              window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
              navigate("/");
            }
          }}
          className="relative cursor-pointer flex items-center gap-2 cursor-pointe"
        >
          <img
            src={chatgptimage}
            alt="Background Logo"
            className="relative inset-0  w-36 object-contain "
          />
          {/* <h2 className="font-bold font-poppins flex">
            <span className="text-black">Surveys</span>
            <span className="text-green-600">IQ</span>
           
          </h2> */}
        </span>

        <div className="hidden md:flex items-center w-full justify-end ml-6">
          <div className="flex items-center space-x-8 font-sans text-green-600 font-bold ml-24">
            {navItems.map((item) => (
              <span
                key={item.path}
                onClick={() => handleNavClick(item)}
                className={`cursor-pointer relative flex items-center justify-center h-10 transition-transform transform origin-center duration-300 ease-in-out ${
                  isActive(item)
                    ? "text-primary-red font-semibold"
                    : "text-black"
                } hover:text-primary-red hover:scale-105`}
              >
                {item.name}
              </span>
            ))}
          </div>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-gray-700 focus:outline-none hover:text-primary-red transition-all duration-300"
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white text-black shadow-md py-4 px-6 space-y-4 text-center">
          {navItems.map((item) => (
            <span
              key={item.path}
              onClick={() => handleNavClick(item)}
              className={`cursor-pointer relative flex items-center justify-center h-10 transition-transform transform origin-center duration-300 ease-in-out ${
                isActive(item) ? "text-primary-red font-semibold" : "text-black"
              } hover:text-primary-red hover:scale-105`}
            >
              {item.name}
            </span>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
